import { BasicRequest } from "./basicRequest";

export class DeleteMoovDefinitionRequest extends BasicRequest{
    public moovDefinitionId! : number;
    public physicalDelete : boolean = false;
}